
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/member-agreement",
      function () {
        return require("private-next-pages/legal/member-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/member-agreement"])
      });
    }
  